import {IShortDescCtx} from "/@lib@/wsp/item.js";
import {POPUP} from "/@back@/commons/widgets/popups.js";
import {IO} from "/@lib@/commons/io/io.js";
import {SrcAction} from "/@back@/wsp/actions/srcActions.js";
import {REG} from "/@lib@/commons/registry.js";
import {ERROR} from "/@lib@/core/errorReport.js";

interface JVersionData {
	srcUri?: string;
	srcDt?: string;
	srcVersLabel?: string;
	srcVersBy?: string;
	srcVersComment?: string;
}

/** Crée une version */
export class CreateVersion<C extends IShortDescCtx> extends SrcAction<C> {
	static SINGLETON = new CreateVersion();

	constructor(id?: string) {
		super(id || "createVersion");
		this._label = "Créer une version...";
		this._group = "versions";
		this._enableSrcPerms = ["action.vers#create.version"];
		this.isBackendDb = true;
		this.exactOne = true;
	}

	isVisible(ctx: C): boolean {
		const item = ctx.shortDescs[0];//mode exactOne
		if (item.srcLiveUri) return false;
		return super.isVisible(ctx);
	}

	async execute(ctx: C, ev?: Event) {
		const comment = await POPUP.prompt("Entrez un commentaire pour cette version :", ctx.emitter);
		if (comment !== undefined) {
			const { wsp, universe } = ctx.reg.env;
			const item = ctx.shortDescs[0];//mode exactOne
			try {
				await universe.wspServer.config.versionUrl.fetchVoid(IO.qs(
					"cdaction",
					"Create",
					"param",
					wsp.code,
					"refUri",
					item.srcUri,
					"comment",
					comment
				), { method: "POST"});

				const versions = await universe.wspServer.config.versionUrl.fetchJson<{ vers: JVersionData[] }>(IO.qs(
					"cdaction",
					"List",
					"param",
					wsp.code,
					"refUri",
					item.srcUri,
					"fields",
					"srcVersLabel"
				), { method: "POST"});
				const lastVersLabel = versions.vers[0].srcVersLabel;
				POPUP.showNotifInfo(`La version ${lastVersLabel} a été crée.`, ctx.emitter);
			} catch (e) {
				await ERROR.report("Une erreur est survenue lors de la création de la version.", e, ctx);
			}
		}
	}
}

REG.reg.registerSvc('vers/createVersionAction', 1, CreateVersion.SINGLETON);